export default __webpack_public_path__ + "static/media/payment-fail.ba4b2367.svg";